module.exports = __webpack_public_path__ + "static/media/arrival.f4f914ab.png";